import { Typography } from 'core/common/ui/ui-kit';
import { Address } from 'core/common/ui/widgets';
import { PaymentContent } from 'core/flow/entities/Content';
import { BrandsImageStyled, FooterStyled, GuaranteeStyled, GuaranteeIconStyled } from './styled';

const PaymentDescription = ({ content }: { content: PaymentContent }) => {
  return (
    <FooterStyled>
      <GuaranteeStyled>
        <GuaranteeIconStyled name="guarantee" width={24} height={24} />
        <Typography variant="bodySmallRegular">{content.guaranteeText}</Typography>
      </GuaranteeStyled>
      <BrandsImageStyled
        src={content.imageSecureBrands.src}
        alt={content.imageSecureBrands.alt}
        width={200}
        height={100}
      />
      <Address />
    </FooterStyled>
  );
};

export default PaymentDescription;
